import { DeprecatedThemeOptions } from "@mui/material/styles";
import { paletteOptions } from "./Overrides/PaletteOverrides";
import { typographyOverrides } from "./Overrides/TypographyOverrides";
import { inputBaseOverrides, textFieldOverrides } from "./Overrides/InputOverrides";
import { buttonOverrides } from "./Overrides/ButtonOverrides";

const theme: DeprecatedThemeOptions = {
  palette: paletteOptions,
  overrides: {
    MuiTypography: typographyOverrides,
    MuiTextField: textFieldOverrides,
    MuiInputBase: inputBaseOverrides,
    MuiButton: buttonOverrides,
  },
};

export { theme as attendanceFormTheme };
